import React from "react";
import { SkipLinkAnchorProps } from "../tools/SkipLink.const";
import clsx from "clsx";

import useStyles from "../SkipLink.style";

export const SkipLinkAnchor = ({
  href,
  label,
  onClick,
  isScreenReaderVisibilityEnabled = false,
}: SkipLinkAnchorProps) => {
  const c = useStyles({ isScreenReaderVisibilityEnabled });
  return (
    <a
      href={href}
      className={clsx(c.root, "SkipLink")}
      onClick={onClick}
      tabIndex={0}
    >
      {label}
    </a>
  );
};
